/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';
import { useStoreId } from '@thd-nucleus/experience-context';

export const usePackages = ({ itemId, callOnLoaded }) => {
  const storeId = useStoreId();
  let previousUrl = '';
  if (typeof window === 'object') {
    previousUrl = document.referrer;
  }
  const previousUrlMatch = previousUrl.match(/package_([a-zA-Z]|[0-9])*/);

  const { loading, data } = useDataModel('packages', {
    variables: {
      packageId: previousUrlMatch ? previousUrlMatch?.[0] : undefined,
      itemId: previousUrlMatch ? undefined : itemId,
      storeId,
      limit: 1
    },
    context: {
      withAuth: true
    },
    ssr: true
  });

  const hasEnoughPackageData = !!(data?.packages?.[0]?.metadata && data?.packages?.[0]?.products?.length > 1);

  useEffect(() => {
    if (data) {
      callOnLoaded({ didRender: hasEnoughPackageData });
    }
  }, [data]);

  const [fulfillmentFetched, setFulfillmentFetched] = useState(false);
  const [itemMap, setItemMap] = useState({});

  useEffect(() => {
    if (data?.packages?.[0]?.products) {
      setItemMap(data.packages[0].products.reduce((map, product) => {
        if (product?.itemId) {
          return {
            ...map,
            [product.itemId]: { ...map[product.itemId], selectedQty: 1 }
          };
        }
        return map;
      }, itemMap));
    }
  }, [data]);

  return {
    data,
    loading,
    hasEnoughPackageData,
    itemMap,
    setItemMap,
    fulfillmentFetched,
    setFulfillmentFetched
  };
};